import React, {useContext} from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import {Center} from "components/EntityList/Components/Center";
import {EntitySubtitle} from "components/EntityList/Components/EntitySubtitle";
import LeftSide from "components/EntityList/Components/LeftSide";
import RightSide from "components/EntityList/Components/RightSide";
import TagList from "components/EntityList/TagList/TagList";
import MultiSelectCheckbox from "components/MultiSelectCheckbox";
import {EntityListContext} from "contexts/EntityListContext";
import css from "./CardListItem.module.scss";

export default function CardListItem({
  title,
  subtitle,
  leftSide,
  rightSide,
  tags,
  minimal = false,
  entity
}) {
  const {selectable, selected, setSelected, withDrawer} =
    useContext(EntityListContext);
  const selectableDrawerItem = selectable && withDrawer;

  const cardContent = (
    <>
      {leftSide && <LeftSide>{leftSide}</LeftSide>}
      <Center>
        {!minimal && <EntitySubtitle>{subtitle}</EntitySubtitle>}
        {title}
      </Center>
      {rightSide && !minimal && <RightSide>{rightSide}</RightSide>}
    </>
  );

  return (
    <div
      role="listitem"
      className={classNames(css.cardItem, "d-flex flex-column justify-center", {
        [css.cardItemMinimal]: minimal,
        "my-3": !minimal && !selectableDrawerItem,
        [css.selectableDrawerItem]: selectableDrawerItem
      })}
      data-testid={"CardListItem-Container"}>
      <div className="d-flex align-center">
        {selectable ? (
          <MultiSelectCheckbox
            {...(entity?.id && {id: entity?.id})}
            data-testid="Entity-Checkbox"
            selected={selected}
            setSelected={setSelected}
            stopPropagation
            value={entity}>
            <div className="d-flex align-center" style={{flexBasis: "100%"}}>
              {cardContent}
            </div>
          </MultiSelectCheckbox>
        ) : (
          cardContent
        )}
      </div>
      {!minimal && (
        <TagList
          tags={tags}
          className={classNames("mt-1", {
            ["ml-6"]: leftSide,
            ["pl-5"]: selectable
          })}
        />
      )}
    </div>
  );
}

CardListItem.propTypes = {
  // leftSide Component
  leftSide: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object
  ]),
  // title can be a string value or component
  title: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // subtitle can be a string value or component
  subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  // rightSide can be a string, number or component
  rightSide: PropTypes.oneOfType([
    PropTypes.number,
    PropTypes.string,
    PropTypes.object
  ]),
  /**
   * Default Value: false - Render normal view (Cards, Drawers, etc.)
   * true - Renders a more compact view used by Tables. note that some sections
   * like 'subtitle' and 'rightSide' event counts are never show in this mode.
   */
  minimal: PropTypes.bool,
  /**
   * Data object for entity
   */
  entity: PropTypes.object
};
